// @ts-ignore
import envConfig from 'environmentConfig';
import HostWrapperMock from '../services/HostWrapperMock';

function isOpenInIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    /**
     * If there is an error it is safer to assume
     * that we are not in IFrame due to Desktop App ingrations
     */
    return false;
  }
}

function isHostedOnLocal() {
  const { hostname } = window.location;
  return hostname.includes('localhost') || hostname.startsWith('local.');
}

function isHostedOnDev() {
  return window.location.hostname.includes('-dev');
}

function isHostedOnStaging() {
  return window.location.hostname.includes('-staging');
}

function isHostedOnProduction() {
  return window.location.hostname === 'sharedviewspanel.autodesk.com';
}

function isAllowedWebHostPanelHost() {
  return isHostedOnLocal() || isHostedOnDev() || isHostedOnStaging() || isHostedOnProduction();
}

function isWebHostAppAllowed() {
  return isOpenInIframe() && isAllowedWebHostPanelHost();
}

function notifyHostAppAndSetAccessToken(hostUrl) {
  const expectedOrigin = new URL(hostUrl).origin;

  window.parent.postMessage({ type: 'getToken' }, expectedOrigin);
  window.addEventListener('message', (event) => {
    if (event.origin !== expectedOrigin) {
      return;
    }

    try {
      const payload = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
      if (!payload || typeof payload.accessToken !== 'string' || !payload.accessToken) {
        return;
      }
      HostWrapperMock.setToken(payload.accessToken);
    } catch {
      // Ignore non-JSON messages (extensions, other frames, etc.)
    }
  });
}

function setUpWebHostAppIfAvailable() {
  const webHostAppConfig = envConfig.get().webHostApp;
  if (!webHostAppConfig) {
    return;
  }
  if (isWebHostAppAllowed()) {
    notifyHostAppAndSetAccessToken(webHostAppConfig.url);
  }
}

export { setUpWebHostAppIfAvailable, isWebHostAppAllowed };
